import { getApiErrorDetail, getApiErrorStatus } from './apiErrorUtils';

export const ACCESS_DENIED_DETAIL = 'You do not have permission to view this EPD.';
export const OWNER_ONLY_DETAIL = 'Only the EPD Owner is allowed to perform this action.';

export const getEpdActionErrorMessage = (error: unknown): string | null => {
  const status = getApiErrorStatus(error);

  if (status !== 403) {
    return null;
  }

  const detail = getApiErrorDetail(error);

  if (detail === ACCESS_DENIED_DETAIL) {
    return ACCESS_DENIED_DETAIL;
  }

  return detail ?? OWNER_ONLY_DETAIL;
};